import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';
import { initializeApp } from 'firebase/app';
import { config, functionsEmulatorHost } from './config';
import type { FnInput, FnResult, FunctionsApi } from '../../../functions';
import { stage } from './config';

const app = initializeApp(config);
const functions = getFunctions(app);

const [host, port] = functionsEmulatorHost?.split(':') || [];
if (host && port) {
  connectFunctionsEmulator(functions, host, Number.parseInt(port));
}

export function callFirebaseFunction<K extends keyof FunctionsApi>(
  functionName: K,
): ReturnType<typeof httpsCallable<FnInput<K>, FnResult<K>>>;

export function callFirebaseFunction(
  functionName: string,
): ReturnType<typeof httpsCallable>;

export function callFirebaseFunction(functionName: string) {
  return httpsCallable(functions, functionName);
}

if (stage === 'dev') {
  (global as any).callFirebaseFunction = callFirebaseFunction;
}
